import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { API } from "../App";
import { toast } from "sonner";

export default function AuthCallback({ setUser }) {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Use ref to prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      try {
        // Extract session_id from URL fragment
        const hash = window.location.hash;
        const sessionIdMatch = hash.match(/session_id=([^&]+)/);
        
        if (!sessionIdMatch) {
          toast.error("Error de autenticación");
          navigate("/login");
          return;
        }

        const sessionId = sessionIdMatch[1];

        // Exchange session_id for session_token
        const response = await axios.post(`${API}/auth/session`, {
          session_id: sessionId
        });

        setUser(response.data);
        toast.success(`¡Bienvenido, ${response.data.name}!`);
        
        // Clean URL and navigate to dashboard
        window.history.replaceState({}, document.title, window.location.pathname);
        navigate("/dashboard", { state: { user: response.data } });
      } catch (error) {
        console.error("Auth error:", error);
        toast.error("Error al iniciar sesión");
        navigate("/login");
      }
    };

    processAuth();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center" data-testid="auth-callback">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto mb-4"></div>
        <p className="text-muted-foreground">Iniciando sesión...</p>
      </div>
    </div>
  );
}
